import { Component } from "react";
import ParametroDetalleRevocacion from "../../../Contenedores/Autorizaciones/ParametroDetalleRevocacion";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";
import { CerrarNotificador, Notificar } from "../../Comunes/Notificador";
import Identificacion from "../../../Contenedores/Comun/Identificacion";
import TipoPersona from "../../../Contenedores/Comun/TipoPersona";
import moment from "moment";
import { _VerificarArray, __EsPersonaFisica } from "../../../Utils/Funciones";
import PersonaFisica from "../Personas/PersonaFisica";
import PersonaJuridica from "../Personas/PersonaJuridica";
import IdentificacionesAsociadas from "../../Comunes/IdentificacionesAsociadas/IdentificacionesAsociadas";
import DocumentosRevocacion from "../../Comunes/Documentos/DocumentosRevocacion";
import DatosUsuario from "../../Comunes/DatosUsuario/DatosUsuario";
import StickyTopBox from "../../Comunes/StickyBox/StickyTopBox";

export default class DetalleRevocacion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Detalle: [],
      DatosRevocacion: [],
      DatosPersona: [],
      DatosRepLegal: [],
      UsuarioTramite: [],
      EsPersonaFisica: false,
      identificacionesAsociadas: [],
      RenderizarDetalle: false,
      Documentos: [],
    };
  }

  async componentDidMount() {
    await this.ConsultarDetalleRevocacion();
  }

  async ConsultarDetalleRevocacion() {
    let datos = this.props.DatosRevocacion;

    let parametro = new ParametroDetalleRevocacion();
    parametro.NumeroRevocatoria = datos.numeroRevocatoria;
    parametro.EntidadAutorizada = datos.entidadRevocada.id;
    parametro.TipoAutorizacion = datos.tipoAutorizacion.codigo;
    parametro.Identificacion = new Identificacion();
    parametro.Identificacion.Codigo = datos.identificacion.codigo;
    parametro.Identificacion.TipoPersona = new TipoPersona();
    parametro.Identificacion.TipoPersona.Codigo =
      datos.identificacion.tipoPersona.codigo;
    parametro.Identificacion.TipoPersona.Clase =
      datos.identificacion.tipoPersona.clase;

    let detalle = await ServicioAutorizaciones.ObtengaDetalleRevocacion(
      parametro
    );

    if (detalle.esValido) {
      CerrarNotificador();
      await this.cargarDatosParaRevocacion(detalle);
    } else {
      Notificar("error", detalle.errores);
    }
  }

  async cargarDatosParaRevocacion(datos) {
    let espersonafisica = await __EsPersonaFisica(
      datos.datosPersona.identificacionPrincipal.tipoPersona.codigo
    );
    let Personafisica = datos.datosPersona;
    let Personajuridica = datos.representanteLegal;

    let asociadas = espersonafisica
      ? _VerificarArray(datos.datosPersona.identificacionesAsociadas)
      : datos.representanteLegal != null
      ? _VerificarArray(datos.representanteLegal?.identificacionesAsociadas)
      : null;
    let usuarioTramite = datos.datosUsuarioTramite;
    let documentos = _VerificarArray(datos.documentos);

    this.setState({
      Detalle: datos,
      EsPersonaFisica: espersonafisica,
      DatosPersona: Personafisica,
      DatosRepLegal: Personajuridica,
      identificacionesAsociadas: asociadas,
      UsuarioTramite: usuarioTramite,
      Documentos: documentos,
      RenderizarDetalle: true,
    });
  }

  render() {
    return (
      <div>
        {this.state.RenderizarDetalle ? (
          <>
            <StickyTopBox>
              <div className="row">
                <div className="col-auto">
                  <button
                    type="button"
                    onClick={() => this.props.VolverAResultados()}
                    className="btn btn-sm btn-primary"
                  >
                    <i className="fas fa-arrow-circle-left"></i>
                  </button>
                </div>

                <div className="col">
                  <h1 className="h3 mb-0 text-gray-800">
                    Detalle de la Revocación
                  </h1>
                </div>
              </div>
            </StickyTopBox>

            <div id="MostrarDatosPersonaFisicaoJuridica">
              {this.state.EsPersonaFisica ? (
                <PersonaFisica DatosPersonaFisica={this.state.DatosPersona} />
              ) : (
                <div>
                  <PersonaJuridica PersonaJuridica={this.state.DatosPersona} />
                  <PersonaFisica
                    DatosPersonaFisica={this.state.DatosRepLegal}
                  />
                </div>
              )}
            </div>
            <div id="identificacionesRelacionadas">
              {this.state.identificacionesAsociadas != null ? (
                <IdentificacionesAsociadas
                  Identificaciones={this.state.identificacionesAsociadas}
                  Titulo={
                    this.state.EsPersonaFisica
                      ? "Identificaciones Asociadas"
                      : "Identificaciones Asociadas Representante Legal"
                  }
                />
              ) : null}
            </div>

            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">
                  Datos de la Autorización
                </h6>
              </div>
              <div className="card-body text-gray-800">
                <div className="form-row">
                  <div className="form-group col-md-4">
                    <label
                      htmlFor="NumeroAutorizacionFormateado"
                      className="col-form-label"
                    >
                      No. Autorización
                    </label>
                    <input
                      type="hidden"
                      id="NumeroAutorizacion"
                      value={this.state.Detalle.numeroAutorizacion}
                      readOnly
                    />
                    <input
                      type="text"
                      id="NumeroAutorizacionFormateado"
                      className="form-control"
                      value={this.state.Detalle.numeroAutorizacionFormateado}
                      readOnly
                    />
                  </div>

                  <div className="form-group col-md-4">
                    <label
                      htmlFor="TipoAutorizacion.Codigo"
                      className="col-form-label"
                    >
                      Tipo Autorización
                    </label>
                    <input
                      type="text"
                      id="tipoAutorizacion"
                      className="form-control"
                      value={this.state.Detalle.tipoAutorizacion?.descripcion}
                      readOnly
                    />
                  </div>
                  <div className="form-group col-md-4">
                    <label
                      htmlFor="entidadAutorizada"
                      className="col-form-label"
                    >
                      Entidad Autorizada
                    </label>
                    <input
                      type="text"
                      id="entidadAutorizada"
                      className="form-control"
                      value={this.state.Detalle.entidadRevocada?.alias}
                      readOnly
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label
                      htmlFor="txtfechaTramiteAutorizacion"
                      className="col-form-label"
                    >
                      Fecha de Trámite
                    </label>
                    <input
                      type="text"
                      name="txtfechaTramiteAutorizacion"
                      id="txtfechaTramiteAutorizacion"
                      value={
                        this.state.Detalle.fechaTramiteAutorizacion != null
                          ? moment(
                              this.state.Detalle.fechaTramiteAutorizacion
                            ).format("DD/MM/YYYY hh:mm A")
                          : ""
                      }
                      className="form-control"
                      readOnly
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label
                      htmlFor="usuarioTramitoAutorizacion"
                      className="col-form-label"
                    >
                      Usuario que Tramitó la Autorización
                    </label>
                    <input
                      type="text"
                      id="usuarioTramitoAutorizacion"
                      className="form-control"
                      value={this.state.Detalle.usuarioTramitoAutorizacion}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">
                  Datos de la Revocación
                </h6>
              </div>
              <div className="card-body text-gray-800">
                <div className="form-row">
                  <div className="form-group col-md-4">
                    <label
                      htmlFor="NumeroRevocatoria"
                      className="col-form-label"
                    >
                      No. Revocación
                    </label>
                    <input
                      type="text"
                      id="NumeroRevocatoria"
                      className="form-control"
                      value={this.state.Detalle.numeroRevocatoria}
                      readOnly
                    />
                  </div>
                  <div className="form-group col-md-4">
                    <label id="lblFecha" className="col-form-label">
                      Entidad Revocada
                    </label>
                    <input
                      type="text"
                      id="EntidadRevocada"
                      className="form-control"
                      value={this.state.Detalle.entidadValidacion?.alias}
                      readOnly
                    />
                  </div>
                  <div className="form-group col-md-4">
                    <label
                      className="col-form-label"
                      htmlFor="txtfechaTramiteRevocacion"
                    >
                      Fecha de Trámite
                    </label>
                    <input
                      type="text"
                      name="txtfechaTramiteRevocacion"
                      id="txtfechaTramiteRevocacion"
                      value={
                        this.state.Detalle.fechaValidacion != null
                          ? moment(this.state.Detalle.fechaValidacion).format(
                              "DD/MM/YYYY hh:mm A"
                            )
                          : ""
                      }
                      className="form-control"
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>

            <div>
              {
                <DatosUsuario
                  Usuario={this.state.UsuarioTramite}
                  Titulo={"Datos del Usuario que Realizó la Revocación"}
                />
              }
            </div>

            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">
                  Datos de la Validación
                </h6>
              </div>
              <div className="card-body text-gray-800">
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label
                      htmlFor="estadoValidacion"
                      className="col-form-label"
                    >
                      Estado
                    </label>
                    <input
                      type="text"
                      id="estadoValidacion"
                      className="form-control"
                      value={this.state.Detalle.estadoRevocacion?.descripcion}
                      readOnly
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="FechaValidacion" className="col-form-label">
                      Fecha de Aprobación
                    </label>
                    <input
                      type="text"
                      id="FechaValidacion"
                      className="form-control"
                      value={
                        this.state.Detalle.fechaValidacion != null
                          ? moment(this.state.Detalle.fechaValidacion).format(
                              "DD/MM/YYYY hh:mm A"
                            )
                          : ""
                      }
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>

            <div>
              {this.state.Documentos != null ? (
                <DocumentosRevocacion Documentos={this.state.Documentos} />
              ) : null}
            </div>
          </>
        ) : null}
      </div>
    );
  }
}
